import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

const sliderBlock = document.querySelector('.services-slider');

if( sliderBlock ) {
  const servicesSlider = sliderBlock.querySelector('.services-slider__slider');

  var initializeBlock = function( $block ) {

    if(!!$block[0]){
      $block = $block[0];
    }
    
    var splide = new Splide( servicesSlider, {
      type: 'fade',
      speed: 1200,
      arrows: true,
      pagination: false,
      keyboard: true,
      // paginationKeyboard: true,
      breakpoints: {
        768: {
          destroy: true,
        },
      }
    });
    splide.mount();

    const numberOfSlides = splide.length

    ScrollTrigger.matchMedia({
      // makes slider sticky (above 960px only)
      "(min-width: 960px)": function() {
        ScrollTrigger.create({
          trigger: sliderBlock,
          start: 'top top+=85px',
          end: 'bottom bottom',
          snap: 1 / (numberOfSlides - 1),
          pin: true,
          onUpdate: function(self){
            const currentProgress = Math.round(self.progress * (numberOfSlides - 1));
            if(splide.index != currentProgress) {
              splide.go(currentProgress);
            }
          },
          pinSpacing: false,
          // markers: true
        });
      }
    });

  }

  // Initialize each block on page load (front end).
  document.addEventListener( 'DOMContentLoaded', function() {
    var sliders = document.querySelectorAll('.services-slider');
    Array.prototype.forEach.call(sliders, function(el, i){
      initializeBlock(el);
    });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=services-slider', initializeBlock );
  }
}